import { domain } from "../auth/domain";

const getAuthHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `JWT ${localStorage.getItem("accessToken")}`,
});

const handleResponse = async (response) => {
  if (response.status === 204) return null;
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const detail = data?.detail || "Request failed";
    throw new Error(detail);
  }
  return data;
};

export const fetchUpatuDisbursements = async () => {
  const response = await fetch(`${domain}group-finance/upatu-disbursements/`, {
    headers: getAuthHeaders(),
  });
  return handleResponse(response);
};

export const initiateUpatuDisbursement = async ({ target_member, amount }) => {
  const response = await fetch(`${domain}group-finance/upatu-disbursements/`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify({ target_member, amount }),
  });
  return handleResponse(response);
};

export const approveUpatuDisbursement = async (id) => {
  const response = await fetch(`${domain}group-finance/upatu-disbursements/${id}/approve/`, {
    method: "POST",
    headers: getAuthHeaders(),
  });
  return handleResponse(response);
};

export const rejectUpatuDisbursement = async (id, reason) => {
  const response = await fetch(`${domain}group-finance/upatu-disbursements/${id}/reject/`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify({ reason }),
  });
  return handleResponse(response);
};
